/**
 * Brand Configuration
 * White-Label / Multi-Brand yapısı için merkezi marka yönetimi
 * 
 * KULLANIM:
 * import { BRAND } from './config/brand';
 * 
 * NOT: .env dosyası olmadan da mevcut değerlerle çalışır (fallback)
 */

// Ofis tipi tanımı
export interface BrandOffice {
  city: string;
  address: string;
  phone: string;
}

// ═══════════════════════════════════════════════════════════════════════════
// TEMEL MARKA BİLGİLERİ
// ═══════════════════════════════════════════════════════════════════════════

export const BRAND = {
  // Marka İsimleri
  name: process.env.REACT_APP_BRAND_NAME || 'GTS',
  fullName: process.env.REACT_APP_BRAND_FULL_NAME || 'İşletme Yönetim Sistemi',
  companyName: process.env.REACT_APP_COMPANY_NAME || 'MT Teknoloji',
  companyFullName: process.env.REACT_APP_COMPANY_FULL_NAME || 'MT Teknolojileri ve Bilişim Hizmetleri',
  copyrightHolder: process.env.REACT_APP_COPYRIGHT_HOLDER || 'AQUASOFT',

  // ═══════════════════════════════════════════════════════════════════════════
  // LOGOLAR
  // ═══════════════════════════════════════════════════════════════════════════
  
  logos: {
    // Ana logo (favicon, genel kullanım)
    main: process.env.REACT_APP_LOGO_MAIN || '/assets/gtslogo.jpg',
    // Koyu arka plan için logo
    dark: process.env.REACT_APP_LOGO_DARK || '/assets/logosiyah.png',
    // Header'da kullanılan logo
    header: process.env.REACT_APP_LOGO_HEADER || '/assets/aquasoft_logo.png',
    // WMS header'da kullanılan logo (beyaz zemin için ayrı tutulur)
    wmsHeader: process.env.REACT_APP_LOGO_WMS_HEADER || '/assets/aquasoft_logo2.png',
    // Yüksek çözünürlüklü logo (fatura, makbuz vb.)
    highRes: process.env.REACT_APP_LOGO_HIGHRES || '/assets/logoHighResNew.png',
    // Hero/Landing sayfası görseli
    hero: process.env.REACT_APP_LOGO_HERO || '/assets/gts_takip_web.png',
    // Login sayfası sol görseli
    login: process.env.REACT_APP_LOGO_LOGIN || '/assets/gorev.png',
    // Muhasebe login görseli
    loginAccounting: process.env.REACT_APP_LOGO_LOGIN_ACCOUNTING || '/assets/muhasebe.png',
    // Login formu üzerindeki marka logosu (yatay/yazılı)
    loginForm: process.env.REACT_APP_LOGO_LOGIN_FORM || '/assets/aquasoft_yazili.jpeg',
    // Welcome anasayfa hero bölümü yatay/yazılı logo (yıldızların yanındaki)
    wordmark: process.env.REACT_APP_LOGO_WORDMARK || '/assets/aquasoft_yazili.jpeg',
  },

  // ═══════════════════════════════════════════════════════════════════════════
  // RENKLER
  // ═══════════════════════════════════════════════════════════════════════════
  
  colors: {
    primary: process.env.REACT_APP_COLOR_PRIMARY || '#0D47A1',
    secondary: process.env.REACT_APP_COLOR_SECONDARY || '#1976D2',
    accent: process.env.REACT_APP_COLOR_ACCENT || '#42A5F5',
    // Panel sidebar default rengi (localStorage'da değer yoksa kullanılır)
    sidebarDefault: process.env.REACT_APP_COLOR_SIDEBAR_DEFAULT || '#102648',
  },

  // ═══════════════════════════════════════════════════════════════════════════
  // İLETİŞİM BİLGİLERİ
  // ═══════════════════════════════════════════════════════════════════════════
  
  contact: {
    email: process.env.REACT_APP_CONTACT_EMAIL || 'info@mt-teknoloji.com',
    phone: process.env.REACT_APP_CONTACT_PHONE || '+90 (380) 523 32 36',
    address: process.env.REACT_APP_CONTACT_ADDRESS || 'Yeni Mahalle Saka sokak No:390 Merkez/Düzce',
    website: process.env.REACT_APP_WEBSITE || 'https://www.mt-teknoloji.com',
    // Müşteri hizmetleri telefonu
    customerService: process.env.REACT_APP_CUSTOMER_SERVICE_PHONE || '+90 (312) 400 09 12',
  },

  // ═══════════════════════════════════════════════════════════════════════════
  // OFİS BİLGİLERİ (İletişim sayfası için)
  // ═══════════════════════════════════════════════════════════════════════════
  
  offices: JSON.parse(process.env.REACT_APP_OFFICES || JSON.stringify([
    {
      city: 'Ankara',
      address: 'Çukurambar Mah. 1480. Sok. No:2/7 Çankaya/Ankara',
      phone: '+90 (312) 400 09 12',
    },
    {
      city: 'İstanbul',
      address: 'Büyükdere Cad. No:185 Şişli/İstanbul',
      phone: '+90 (850) 441 94 32',
    },
    {
      city: 'Sakarya',
      address: 'Arabacıalanı Mah. 54100 Adapazarı/Sakarya',
      phone: '+90 (850) 441 94 32',
    },
    {
      city: 'Düzce',
      address: 'Yeni Mahalle Saka sokak No:390 Merkez/Düzce',
      phone: '+90 (380) 523 32 36',
    }
  ])) as BrandOffice[],

  // ═══════════════════════════════════════════════════════════════════════════
  // MOBİL UYGULAMA LİNKLERİ
  // ═══════════════════════════════════════════════════════════════════════════
  
  apps: {
    playStore: process.env.REACT_APP_PLAYSTORE_URL || 'https://play.google.com/store/apps/details?id=com.mt_teknoloji.gts',
    appStore: process.env.REACT_APP_APPSTORE_URL || 'https://apps.apple.com/app/gts-gorev-takip-sistemi/id6738154803',
    // Apple Sign-In için redirect URI
    appleRedirectUri: process.env.REACT_APP_APPLE_REDIRECT_URI || 'https://aquasoft.com.tr',
    // Windows uygulaması
    windowsApp: process.env.REACT_APP_WINDOWS_APP_URL || 'https://gts.mt-teknoloji.com/GTS.exe',
  },

  // ═══════════════════════════════════════════════════════════════════════════
  // SOSYAL MEDYA
  // ═══════════════════════════════════════════════════════════════════════════
  
  social: {
    facebook: process.env.REACT_APP_SOCIAL_FACEBOOK || 'https://www.facebook.com/MTTeknoloji',
    twitter: process.env.REACT_APP_SOCIAL_TWITTER || 'https://x.com/mtmurattastepe',
    linkedin: process.env.REACT_APP_SOCIAL_LINKEDIN || 'https://www.linkedin.com/in/mt-teknoloji-a62843164/?originalSubdomain=tr',
    instagram: process.env.REACT_APP_SOCIAL_INSTAGRAM || 'https://www.instagram.com/mt_teknoloji/',
  },

  // ═══════════════════════════════════════════════════════════════════════════
  // PUBLIC URL'LER (QR Kodlar, Anketler vb.)
  // ═══════════════════════════════════════════════════════════════════════════
  
  urls: {
    base: process.env.REACT_APP_PUBLIC_URL || 'https://aquasoft.com.tr',
    // Dinamik URL oluşturucular
    survey: (taskId: string) => `${BRAND.urls.base}/#/surveys/${taskId}`,
    qrMenu: (menuId: string) => `${BRAND.urls.base}/#/qr-menu/${menuId}`,
    reservation: (companyId: string, branchId: string) => `${BRAND.urls.base}/#/reservation/${companyId}/${branchId}`,
  },
};

// ═══════════════════════════════════════════════════════════════════════════
// TİP TANIMLARI (TypeScript desteği)
// ═══════════════════════════════════════════════════════════════════════════

export type BrandConfig = typeof BRAND;
export type BrandColors = typeof BRAND.colors;
export type BrandLogos = typeof BRAND.logos;

// ═══════════════════════════════════════════════════════════════════════════
// YARDIMCI FONKSİYONLAR
// ═══════════════════════════════════════════════════════════════════════════

/**
 * Marka rengini CSS değişkeni olarak döndürür
 * @example getBrandColorVar('primary') => 'var(--brand-primary, #0D47A1)'
 */
export const getBrandColorVar = (colorKey: keyof BrandColors): string => {
  const color = BRAND.colors[colorKey];
  if (typeof color === 'string') {
    return `var(--brand-${colorKey}, ${color})`;
  }
  return BRAND.colors.primary;
};

/**
 * Gradient stilleri
 */
export const BRAND_GRADIENTS = {
  // Ana gradient (Header, Hero vb.)
  primary: `linear-gradient(135deg, ${BRAND.colors.primary} 0%, ${BRAND.colors.secondary} 50%, ${BRAND.colors.accent} 100%)`,
  // Dikey gradient
  vertical: `linear-gradient(to bottom, ${BRAND.colors.primary}, ${BRAND.colors.secondary})`,
  // Ters gradient (Footer vb.)
  reverse: `linear-gradient(135deg, ${BRAND.colors.accent} 0%, ${BRAND.colors.secondary} 50%, ${BRAND.colors.primary} 100%)`,
  // Açıktan koyuya (90 derece)
  horizontal: `linear-gradient(90deg, ${BRAND.colors.primary} 0%, ${BRAND.colors.secondary} 50%, ${BRAND.colors.accent} 100%)`,
};

/**
 * Copyright metni oluşturur
 * @example getCopyright() => '© 2026 AQUASOFT'
 */
export const getCopyright = (includeYear: boolean = true): string => {
  if (includeYear) {
    return `© ${new Date().getFullYear()} ${BRAND.copyrightHolder}`;
  }
  return `© ${BRAND.copyrightHolder}`;
};

export default BRAND;
